export default "__VITE_ASSET__CaK7taAd__"